import React, { Suspense, lazy } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import MainNavbar from "./components/navbar/Navbar";
import Spinner from 'react-bootstrap/Spinner';

const Home = lazy(() => import("./components/home/Home"));
const Project = lazy(() => import("./pages/projects/Project"));
const ProjectDetails = lazy(() =>
  import("./components/project details/ProjectDetails")
);
const Resume = lazy(() => import("./pages/resume/Resume"));
const PageNotFound = lazy(() => import("./pages/pageNotFound/PageNotFound"));
const SignIn = lazy(() => import("./pages/auth/SignIn"));

function App() {
  return (
    <div className="App">
      <MainNavbar />
      <Suspense
        fallback={
          <div className="flex justify-center items-center h-screen gap-3">
            <h3 className="font-montserrat">Loading...</h3>
            <Spinner
              animation="border"
              variant="primary"
              className="spinner-main"
            />
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Project />} />
          <Route path="/projects/:title" element={<ProjectDetails />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/admin-sign-in" element={<SignIn />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
